<template>
  <div class="preRepayment-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        @row-click="goDetail"
      >
        <!-- :span-method="spanMethod" -->
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            @click="goAddPayment"
            size="small"
            type="primary"
            icon="el-icon-plus"
          >
            新增
          </el-button>
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-edit"
            @click.stop="handleEdit"
            >编辑
          </el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-arrow-delete"
            @click.stop="handleDelete()"
            >删除
          </el-button>
          <el-button
            size="small"
            icon="el-icon-download"
            @click="exportShow"
          >导出数据
          </el-button>
        </template>
        <template slot="projectNameSearch">
          <CommonSelect

            ref="projectName"
            searchKey="projectName"
            bindLabel="projectName"
            bindKey="id"
            bindValue="projectName"
            methods="get"
            dataMethod="params"
            dataUrl="/bl/blcontractrental/planViewPage"
            @handleChange="(el) => setChangeParam(el)"
          />
        </template>
        <template slot="investBatch" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.investBatch ? `第${row.investBatch}批/第${row.paymentBatch}笔` : row.investBatch }}
          </div>
        </template>
      </avue-crud>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      width="50%"
      title="新增还款"
      :visible.sync="dialogVisble"
    >
      <el-form :model="addForm">
        <el-form-item label="项目名称">
          <CommonSelect
                ref="projectSelect"
                bindLabel="name"
                bindKey="id"
                bindValue="name"
                dataUrl="bl/blreportstandard/page"
                methods="get"
                dataMethod="params"
                searchKey="name"
                placeholder="请选择项目"
                :initParam="initParam"
                @handleChange="setSurveyProjectInfo"
            />
        </el-form-item>
        <el-form-item label="合同名称" :label-width="formLabelWidth" v-if="addForm.projectId != ''">
            <CommonSelect
                ref="contractSelect"
                bindLabel="contractName"
                bindKey="id"
                bindValue="contractName"
                dataUrl="bl/blcontractmanage/searchList"
                methods="get"
                dataMethod="params"
                searchKey="contractName"
                placeholder="请选择合同"
                :initParam="contractParam"
                @handleChange="setContractInfo"
            />
        </el-form-item>
        <el-form-item label="放款批次" :label-width="formLabelWidth" v-if="addForm.contractId != ''">
          <el-select size="small" v-model="addForm.batchId" clearable placeholder="请选择批次">
            <el-option
              v-for="item in batchList"
              :key="item.id"
              :label="item.tableName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="submit-con" v-if="addForm.batchId">
        <el-button
          type="primary"
          size="mini"
          @click="addNewRent()"
        >新增</el-button>
        <el-button
          type="primary"
          size="mini"
          plain
          @click="dialogVisble = false"
        >取消</el-button>
      </div>

    </el-dialog>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import util from "@/mixins/util";
import workFlow from '@/mixins/workFlow'
import { earnoutListConfig } from "./config.js";
import Frame from "@/components/frame/frame";
import CommonDetail from "@/components/commonDetail/commonDetail";
import * as api from "@/api/factoring/factoringScheme";
import { deleteRentPlanLending } from "@/api/factoring/factoring";
import CommonSelect from "@/components/commonSelect/commonSelect";
import { downLoadTemplateGet } from "@/router/downLoadTem";
import { mapGetters } from "vuex";
export default {
  name: "PreRepayment",
  mixins: [util,workFlow],
  data() {
    return {
      addForm: {
        projectId: '',
        contractId: '',
        batchId: ''
      },
      initParam: { auditStatus: 2 },
      contractParam: {},
      batchParam: {},
      dialogVisble: false,
      drawer: false,
      tableData: [],
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      tableConfig: earnoutListConfig(
        this.getMoney,
        this.dateConvert,
        this.selectPersonClick,
        this.selectDeptClick
      ),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      bondVisible: true,
      detail: {},
      selectionList: [],
      batchList: [],
      rules: {
        projectId: [
          { required: true, message: '请选择项目'},
        ],
        contractId: [
          { required: true, message: '请选择合同' }
        ],
        batchId: [
          { required: true, message: '请选择批次' }
        ],
      }
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
    Frame,
    CommonDetail,
    CommonSelect,
  },
  computed: {
      ...mapGetters(["userInfo"])
  },
  mounted() {},
  methods: {
    async handleEdit() {
      // let data = this.selectionList[0]
      // this.$router.push({
      //   path: `/factoring/preRepayment/preRepaymentEdit/${data.id}`
      // })
      let self=this
      if(this.selectionList.length > 1){
                this.$message.error('只能选择一条数据进行编辑')
            } else if(this.selectionList.length == 1){
                let data = this.selectionList[0]
                let processDetail= await self.queryTaskDetail(data.flowableId)
                let flowData=processDetail.flowData
                let presentFlow = flowData[flowData.length - 1]
                if (data.auditStatus == 0||(presentFlow.historyActivityId ==
                 flowData[0].historyActivityId)) {
                    if(data.managerUser == this.userInfo.user_id || data.assistUser == this.userInfo.user_id){
                        this.$router.push({
                            path: `/factoring/preRepayment/preRepaymentEdit/${data.id}`
                        })
                    }else {
                        this.$message.warning('您暂无权限对该条数据进行编辑')
                    }
                }else {
                    this.$message.warning('该条数据已提交审核无法编辑')
                }
            }else {
                this.$message.error('请选择一条数据进行编辑')
            }  

    },
    goAddPayment() {
      this.$router.push({
        path: '/factoring/preRepayment/preRepaymentAdd'
      })
    },
    // 新增还款计划
    async addNewRent() {
      // 校验是否已经选择ID
      if(this.addForm.batchId == '') {
        this.$message.error('请先选择还款批次')
      }else {
        let res = await api.generateRentPlan({id: this.addForm.batchId})
        if(res.data.data.code == 200) {
          this.$message.success('新增成功')
          this.queryTableData()
          this.$router.push({
            path: `/factoring/preRepayment/preRepaymentDetail/${res.data.data.id}`
          })
        }
      }
    },

    async handleDelete() {
      let self = this
      let startDelete = () => {
        self.$confirm('确定删除选择的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.deleteData()
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行删除')
      } else if(this.selectionList.length == 1){
        if(this.selectionList[0].createUser == this.userInfo.user_id || this.selectionList[0].assistUser == this.userInfo.user_id){
          let data = this.selectionList[0]
          if(data.flowableId != '' && data.auditStatus == 1) {
            // 获取流程数据
            await this.queryFlowData(data.flowableId)
            let presentFlow = this.flowData[this.flowData.length - 1]
            if(this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
              startDelete()
            }else {
              this.$message.error('流程审批中不能删除')
            }
          }else {
            // 直接弹框提示
            startDelete()
          }
        } else {
          this.$message.error('您没有权限删除此条数据')
        }
      }else{
        this.$message.error('请选择数据进行删除')
      }
    },

    async deleteData() {
      let data = this.selectionList[0];
      let res = await deleteRentPlanLending({ loadId: data.loadId });
      if (res.data.code == 200) {
        this.queryTableData();
        this.$message({
          type: "success",
          message: "删除成功",
        });
      }
    },

    // 选择尽调项目后回显项目信息
    // setSurveyProjectInfo(data) {
    //     if(JSON.stringify(data) != '{}'){
    //         this.addForm.projectId = data.projectId
    //         this.contractParam = { projectInfoId: data.id }
    //     }else{
    //       this.addForm = {
    //         projectId: '',
    //         contractId: '',
    //         batchId: ''
    //       }
    //       if(this.$refs.contractSelect) this.$refs.contractSelect.clearBindItem()
    //     }
    // },

    // async setContractInfo(data) {
    //   if(JSON.stringify(data) != '{}') {
    //     this.addForm.contractId = data.id
    //     this.batchParam = { contractId: data.id}
    //     // 查询批次
    //     let res = await api.getBatchList({contractId: data.id})
    //     console.info(res , 'ceshi')
    //     let batchList = res.data.data
    //     batchList.map(item => {
    //       item.tableName = `第${item.investBatch}批/第${item.paymentBatch}笔`
    //     })
    //     this.batchList = batchList
    //   }
    // },

    selectionChange(data) {
      this.selectionList = data
    },

    addNewRepay() {
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行新增还款')
      }else if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        this.$router.push({
          path: `/factoring/earnoutManage/earnoutDetail/${data.id}`,
        })
      }else{
        this.$message.error('请选择一条数据进行新增还款')
      }
    },

    cloudTages(data) {
      this.searchForm = data
    },
    goDetail(row) {
      this.$router.push({
        path: `/factoring/preRepayment/preRepaymentDetail/${row.id}`,
      });
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      const span = column["property"] + "-span";

      if (row[span]) {
        return row[span];
      }
    },
    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,

      };
      let res = await api.getPlanViewPageList(params);
      if (res.data.code == 200) {
        let tableData = res.data.data.records.map((item, index) => {
          return {
            // index: (this.page.currentPage - 1) * 10 + index + 1,
            ...item,
          };
        });

        this.tableData = this.mergeTableRow({
          data: tableData,
          mergeColNames: ["projectName", "custName", "contractName"], // 需要合并的列，默认合并列相同的数据
          firstMergeColNames: ["projectName"], // 受影响的列，只合并以firstMerge为首的同类型数据
          firstMerge: "projectName", // 以哪列为基础进行合并，一般为第一列
        });

        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    setChangeParam(data) {
      this.searchForm["id"] = data["id"];
    },
    //清空
    searchReset() {
      let that = this;
      // that.$refs.projectName.resetList();
      that.searchForm = {};
      that.page.currentPage = 1;
      that.queryTableData();
    },
    //搜索
    searchChange(params, done) {
      this.queryTableData();
      done();
    },
    //导出数据
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
      };
      if (value.code == 1) {
        data = {
          ...data,
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplateGet("/api/bl/blcontractrental/planViewExport", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.preRepayment-list-container {
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px 20px !important;
  }
  // /deep/ .el-form-item__label {
  //   font-weight: 700;
  //   font-style: normal;
  //   color: #999999;
  //   text-align: right;
  //   min-width: 80px;
  //   padding-right: 12px;
  // }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
  .submit-con {
    text-align: center;
    // margin-bottom: 15px;
    button {
      width: 100px;
    }
  }
}
/deep/ .el-dialog__body {
  padding-top: 0px !important;
}
</style>
